// extracted by mini-css-extract-plugin
export default {"entraSignIn":"FYoyE","loginButtonInner":"cEx0X","loginButtonLabel":"CTcqv"};